import { defineField, defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";
import { orderRankField } from "@sanity/orderable-document-list";
import { FcTimeline } from "react-icons/fc";

export default defineType({
  name: "genericCruiseInclusions",
  type: "document",
  title: "Generic Cruise Inclusions",
  icon: FcTimeline,
  preview: {
    select: {
      title: "title"
    },
    prepare: ({ title }) => {
      return {
        title: multilingualStringPreview(title)
      };
    }
  },
  fields: [
    defineField({
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "inclusions",
      title: "Inclusions",
      type: "array",
      of: [{ type: "cruiseGroupInclusion" }]
    }),
    orderRankField({ type: "genericCruiseInclusions" })
  ]
});
